export default "__VITE_ASSET__3ca0d635__"